import { createFileRoute } from "@tanstack/react-router";
import { InstrumentPage } from "@/features/experiments/instruments-page";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/instruments/$id")({
  validateSearch: uploadSearch,
  component: Page,
});
function Page() {
  const { id } = Route.useParams();
  return <InstrumentPage id={id} />;
}
